import React from 'react';

interface TaskQuestionProps {
    fill?: string;
}

export const TaskQuestion = ({ fill }: TaskQuestionProps) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4691_12911)">
                <path
                    d="M7 0C3.13111 0 0 3.13075 0 7C0 10.8688 3.13075 14 7 14C10.8689 14 14 10.8693 14 7C14 3.13111 10.8693 0 7 0ZM6.79287 10.2763C6.39666 10.2763 6.0926 9.94459 6.0926 9.56678C6.0926 9.17979 6.40588 8.85732 6.79287 8.85732C7.17989 8.85732 7.50233 9.17982 7.50233 9.56681C7.50233 9.94457 7.18905 10.2763 6.79287 10.2763ZM7.84325 6.692C7.33649 7.08821 7.32725 7.36463 7.32725 7.84375C7.32725 8.01886 7.2351 8.22155 6.78363 8.22155C6.40582 8.22155 6.27687 8.08333 6.27687 7.60421C6.27687 6.81179 6.627 6.43401 6.89421 6.20367C7.19827 5.94565 7.71427 5.66005 7.71427 5.1625C7.71427 4.73862 7.34571 4.53592 6.88499 4.53592C5.94516 4.53592 6.14789 5.24543 5.65029 5.24543C5.40151 5.24543 5.09745 5.07954 5.09745 4.72021C5.09745 4.22267 5.66871 3.48551 6.91264 3.48551C8.09203 3.48551 8.87523 4.13973 8.87523 5.00585C8.87523 5.87196 8.09203 6.49852 7.84325 6.692Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_4691_12911">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
